import { createRouter, createWebHistory } from 'vue-router';
import { auth, authReadyPromise } from '@/firebase';

export const ADMIN_EMAILS = ['sukminpark@gmail.com', 'asgs.t200080@ggh.goe.go.kr'];

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/app',
      name: 'Home',
      component: () => import('@/components/StudentMain.vue'),
    },
    {
      path: '/app/',
      redirect: { name: 'Home' },
    },
    {
      path: '/home',
      redirect: { name: 'Home' },
    },
    {
      path: '/payment',
      name: 'Payment',
      component: () => import('@/components/PaymentPage.vue'),
    },
    {
      path: '/payment/approve',
      name: 'PaymentApprove',
      component: () => import('@/components/PaymentApprove.vue'),
    },
    {
      path: '/payment/cancel',
      name: 'PaymentCancel',
      component: () => import('@/components/PaymentCancel.vue'),
    },
    {
      path: '/payment/fail',
      name: 'PaymentFail',
      component: () => import('@/components/PaymentFail.vue'),
    },
    {
      path: '/payment/success',
      name: 'PaymentSuccess',
      component: () => import('@/components/PaymentSuccess.vue'),
    },
    {
      path: '/account',
      name: 'Account',
      component: () => import('@/components/AccountPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/admin',
      name: 'AdminPage',
      component: () => import('@/components/AdminPage.vue'),
      meta: { requiresAdmin: true },
    },
  ],
});

router.beforeEach(async (to) => {
  const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin);
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (!requiresAdmin && !requiresAuth) {
    return true;
  }

  await authReadyPromise;

  const { currentUser } = auth;
  if (requiresAuth && !currentUser) {
    return {
      name: 'Home',
      query: { auth: 'google', next: 'account' },
    };
  }
  if (currentUser && ADMIN_EMAILS.includes(currentUser.email)) {
    return true;
  }

  return requiresAdmin ? {
    name: 'Home',
    query: {
      ...to.query,
      notice: 'admin-denied',
    },
  } : true;
});

export default router;
